// vue
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { VueAxios } from './utils/request'
// 获取用户权限
import './permission'
// svg
import './icons'
// element-ui
import 'normalize.css/normalize.css'
import ElementUI from 'element-ui'
import DonMessage from '@/utils/message'
import 'element-ui/lib/theme-chalk/index.css'
// 用户信息缓存
import { getApp } from './utils/lfStore'
// 样式
import '@/styles/index.scss'
// 语言切换
import i18n from './lang'
// echarts
import echarts from 'echarts'
// 自定义全局组件
import checkedFilter from '@/components/filterList'
import appAuthorizeButton from '@/components/authorizeBtn'
import appSearch from '@/components/search'
import appSearchButton from '@/components/searchButton'
import dialogHeader from '@/components/dialogHeader'
import intestCalendar from '@/components/calendar'
import vueLicenseplate from '@/components/licenseplate'
import vueLinetitle from '@/components/linetitle'
// 全局自定义指令
import waves from '@/directive/waves'
import elDragDialog from '@/directive/el-dragDialog'
// 日历
import VCalendar from 'v-calendar'
// 地图
import VueMap from '@vue-map/google'
import JsonViewer from 'vue-json-viewer'
import 'vue-json-viewer/style.css'
// 解决 vue-router.esm.js报错 Uncaught (in promise)问题
import VueRouter from 'vue-router'
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(VueAxios)
Vue.use(ElementUI, {
  size: 'small',
  i18n: (key, value) => i18n.t(key, value)
})
  .use(checkedFilter)
  .use(appAuthorizeButton)
  .use(appSearch)
  .use(appSearchButton)
  .use(dialogHeader)
  .use(waves)
  .use(elDragDialog)
  .use(JsonViewer)
  .use(VCalendar, {
    componentPrefix: 'vc',
    screens: {
      tablet: '576px',
      laptop: '992px',
      desktop: '1200px'
    }
    // locales: {
    //   'pt-PT': {
    //     firstDayOfWeek: 1,
    //     masks: {
    //       title: 'YYYY-MM-DD',
    //     }
    //   }
    // }
  })
  .use(intestCalendar)
  .use(VueMap)
  .use(vueLicenseplate)
  .use(vueLinetitle)
  // VueMap.initMapApiLoader({
  //   key: 'AIzaSyDvMHFM2NM3LvaisWfXuTsaaV1J3qCw0VU'
  // })
VueMap.initMapApiLoader({
  key: 'AIzaSyDAeV5zJQMxLlDf5YmLmr1CI6NHJSBZB9M' // old key
  // key: 'AIzaSyAwp5co1LqtL-8ueHR_R2uP85GAdgC9b84'  // new key
})
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

Vue.prototype.$message = new DonMessage()

getApp().then(data => {
  if (data) {
    store.commit('setApp', data)
    i18n.locale = data.language
  }
});
// 时间格式转换
(function() {
  Date.prototype.format = function(format) {
    var o = {
      'M+': this.getMonth() + 1, // month
      'd+': this.getDate(), // day
      'h+': this.getHours(), // hour
      'm+': this.getMinutes(), // minute
      's+': this.getSeconds(), // second
      'q+': Math.floor((this.getMonth() + 3) / 3), // quarter
      'S': this.getMilliseconds() // millisecond
    }
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
      }
    }
    return format
  }
})(window)

window.vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
